export const nullIfEmpty = <T>(s: T | null | undefined): T | null => {
  if (s === undefined || s === null) {
    return null;
  }
  if (typeof s === "string" && s.length === 0) {
    return null;
  }
  return s;
};
